import React, { ReactNode, useEffect } from "react";
import { Colors } from "../../Constants/colors";
import BackButtonIcon from "./../../images/back.svg";
import {
  HeaderNavigation,
  HeaderNavigationProps,
} from "../Header/HeaderNavigation";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  header: string | null;
  children: ReactNode;
  headerComponent?: ReactNode;
  headerNavigation?: HeaderNavigationProps[] | null;
}
const Wrapper = ({
  header,
  children,
  headerNavigation,
  headerComponent,
}: Props) => {
  const navigate = useNavigate();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const section = searchParams.get("section");

  useEffect(() => {
    if (headerNavigation && headerNavigation.length > 0) {
      const isValidSection = headerNavigation.some(
        (nav) => nav.section === section,
      );
      if (!isValidSection) {
        navigate(`?section=${headerNavigation[0].section}`, {
          replace: true,
        });
      }
    }
  }, [section, headerNavigation, navigate]);

  return (
    <div>
      <div
        className="mb-5 pb-4"
        // style={{
        //   marginTop: isMobile ? "65px" : undefined,
        // }}
      >
        <div className="flex justify-center items-center mb-2 gap-3">
          <div
            className="flex justify-center items-center p-2"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: Colors.White,
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
              cursor: "pointer",
            }}
            onClick={() => {
              navigate(-1);
            }}
          >
            <img src={BackButtonIcon} alt={"back"} />
          </div>
          <div className="Header text-2xl font-medium flex-1">{header}</div>
        </div>

        <div>
          <span style={{ color: Colors.DarkGrey }}>Home</span>{" "}
          <span style={{ color: Colors.TangerineOrange }}>{">"} Teachers</span>
        </div>

        {headerComponent ? (
          <div className="mt-6">{headerComponent}</div>
        ) : (
          <></>
        )}

        {headerNavigation ? (
          <div className="mt-4">
            <HeaderNavigation headerNavigation={headerNavigation} />
          </div>
        ) : (
          <></>
        )}
      </div>
      {children}
    </div>
  );
};
export default Wrapper;
